import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import "../CSS/FullPageLoader.css"; // Import CSS file

export default function FullPageLoader({ open }) {
  return (
    <Backdrop open={open} className="full-page-loader">
      <Box className="full-loader-box">
        <CircularProgress size={80} thickness={4} color="inherit" />
        <Typography sx={{ mt: 2, color: "#7ba424" }}>Loading...</Typography>
      </Box>
    </Backdrop>
  );
}
